import SlugService from '~/passporter-services/shared/slug'
import { BaseNavigation } from '~/services/navigation/baseNavigation'
import Settings from '../settings'

export class DestinationNavigation extends BaseNavigation {
	static toDestination(destinationId: string, destinationName: string, countryName?: string): void {
		this.navigateTo(this.destinationUrl(destinationId, destinationName, countryName))
	}

	static destinationUrl(
		destinationId: string,
		destinationName: string,
		countryName?: string
	): string {
		const nameSlug: string = SlugService.normalize(destinationName)
		let route = `/destinations/${nameSlug}/${destinationId}`
		if (countryName) {
			const countrySlug: string = SlugService.normalize(countryName)
			route = `/destinations/${countrySlug}/${nameSlug}/${destinationId}`
		}
		return route
	}

	static completeDestinationUrl(
		destinationId: string,
		destinationName: string,
		countryName?: string
	): string {
		const path = this.destinationUrl(destinationId, destinationName, countryName)
		const route = `${Settings.baseUrl()}${path}`
		return route
	}

	static openExternalNavigationTo(url: string): void {
		this.navigateToNewTab(url)
	}
}
